import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';
import { type PatchGroupParams } from '@app/client/resources/groups';

import { PODS_SIDEBAR_FOLLOWING_CACHE_KEY } from './useGetGroups';
import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query useMutation to update a group.
 */
export const useUpdateGroup = () => {
    const queryClient = useQueryClient();

    return useMutation(({ id, value }: PatchGroupParams) => Groups.callPatchGroup({ id, value }), {
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries(PODS_SIDEBAR_FOLLOWING_CACHE_KEY);
            queryClient.invalidateQueries(groupsCacheKeys.group(variables.id));
        },
        onError: (_e: Error, variables) => {
            queryClient.invalidateQueries(groupsCacheKeys.group(variables.id));
        },
    });
};
